// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getFunctions,
  connectFunctionsEmulator,
  httpsCallable,
} from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { CloudFunctionNames, isDEV, useLocalCloudFunction } from "./constants/applicationConstants";

const productionDatabaseURL =
  "https://unfpa-vr-default-rtdb.asia-southeast1.firebasedatabase.app";
const devDatabaseURL =
  "https://unfpa-vr-dev.asia-southeast1.firebasedatabase.app";
const databaseURL = isDEV ? devDatabaseURL : productionDatabaseURL;

const firebaseConfig = {
  apiKey: "AIzaSyD_jTjpp2M2N9jQ1cPilpXuQMG7lsl_UCs",
  authDomain: "unfpa-vr.firebaseapp.com",
  databaseURL: databaseURL,
  projectId: "unfpa-vr",
  storageBucket: "unfpa-vr.appspot.com",
  messagingSenderId: "31587509238",
  appId: "1:31587509238:web:4556cd77cf392f29959dd7",
  measurementId: "G-ZNXZ8H1DKY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const functions = getFunctions(app, "asia-south1");

// if (isDEV && (window.location.hostname === "localhost" || useLocalCloudFunction)) {
if (isDEV && (useLocalCloudFunction)) {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);

  // test the sample function
  let cloudRef = httpsCallable(functions, CloudFunctionNames.sample);
  cloudRef()
    .then((res) => {
      console.log(res, "res");
      console.log("sample function tested successfully");
    })
    .catch((err) => {
      console.log(err, "err");
    });
}
export const auth = getAuth(app);

export const db = getFirestore(app, isDEV ? "dev-db" : undefined);
